// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { spacing } from '@iheartjane/reefer-emotion';

export const Row = styled.tr<{ hideBottomBorder: boolean }>(
  ({ hideBottomBorder }) => {
    const theme = useTheme();

    return {
      '& td:first-of-type, th:first-of-type': {
        ...spacing({ pl: 24 }),
      },
      '& td:last-of-type, th:last-of-type': {
        ...spacing({ pr: 24 }),
      },
      '& td': {
        borderBottomColor: hideBottomBorder
          ? theme.colors.background
          : theme.colors.grays.light,
      },
      display: 'table-row',
      verticalAlign: 'middle',
      zIndex: 1,
    };
  }
);
